import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";

@Injectable({ providedIn: "root" })
export class DownloadService {
    downloadFile(fileUrl: string, fileName: string) {
        FileSaver.saveAs(fileUrl, fileName);
    }
}
